// components/MobileNavigation/DropdownContent.tsx
import React from 'react';
import AboutSection from './AboutSection';
// import QuickLinksSection from './QuickLinksSection';
import EthicsComplianceSection from './EthicsComplianceSection';
import DefaultSection from './DefaultSection';

interface DropdownContentProps {
  itemId: string;
  dropdownData: any[];
  activeItem: string;
  onNavClick: (itemId: string) => void;
}

const DropdownContent: React.FC<DropdownContentProps> = ({ 
  itemId, 
  dropdownData, 
  activeItem, 
  onNavClick 
}) => {
  const renderContent = () => {
    switch (itemId) {
      case 'about':
        return <AboutSection sections={dropdownData} activeItem={activeItem} onNavClick={onNavClick} />;
      // case 'quick-links':
      //   return <QuickLinksSection items={dropdownData.flatMap(section => section.items)} activeItem={activeItem} onNavClick={onNavClick} />;
      case 'ethics-compliance':
        return <EthicsComplianceSection items={dropdownData.flatMap(section => section.items)} activeItem={activeItem} onNavClick={onNavClick} />;
      default:
        return <DefaultSection sections={dropdownData} activeItem={activeItem} onNavClick={onNavClick} />;
    }
  };

  return (
    <div className="ml-4 pl-4 border-l-2 border-gray-200 bg-gray-50/30 rounded-r-lg p-4">
      {renderContent()}
    </div>
  );
};

export default DropdownContent;